import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { InfoPage, PortalOneColumnLayout } from 'components/PortalStructure';
import { InfoPageHeaderSection, InfoPageHeaderTitle, InfoPageSection, InfoPageTitle3 } from 'components';
import { Helmet } from 'react-helmet';
const { asyncConnect } = require('redux-connect');

interface IProps {
	baseUrlClient?: string;
}

@asyncConnect([
	{
		promise: () => {
			return Promise.all([]);
		},
	},
])
@connect((state: IStore) => ({
	baseUrlClient: state.fetchDefault.baseUrlClient,
}))
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalDeliveryAndReturnsIT extends React.Component<IProps, any> {
	public render() {
		const siteTitle = 'Consegna e resi';
		const siteDescription = 'Consegna e resi descrizione';
		const siteKeywords = 'Consegna e resi parole chiave';
		const siteImage = this.props.baseUrlClient + '/images/logo.png';
		const siteUrl = this.props.baseUrlClient + '/deliveryandreturns/it';

		return (
			<PortalOneColumnLayout>
				<InfoPage>
					<InfoPageHeaderSection>
						<InfoPageHeaderTitle>Consegna e resi</InfoPageHeaderTitle>
					</InfoPageHeaderSection>
					<InfoPageSection>
						<InfoPageTitle3>CONSEGNA</InfoPageTitle3>

						<ul>
							<li>Quanto tempo ci vorrà per consegnare il mio articolo?</li>
						</ul>

						<p>
							Questo può variare in base al metodo di consegna che il venditore ha fornito o che ha scelto, così come il
							luogo in cui l'articolo viene consegnato da o per. Le consegne all'interno del vostro paese saranno
							normalmente più rapide rispetto alle consegne internazionali, a seconda del metodo di spedizione scelto.
							Alcuni venditori utilizzano servizi di spedizione che vi permetteranno di tracciare la consegna.
						</p>
						<ul>
							<li>Quali metodi di spedizione posso scegliere?</li>
						</ul>
						<p>
							Ha un certo numero di metodi di spedizione a seconda di ciò che il venditore ha deciso di offrire. Se un
							metodo di spedizione che si desidera non è disponibile, è necessario contattare il venditore e chiedere se
							sono disposti ad offrire il metodo di spedizione alternativo e aggiungerlo alla loro lista.
						</p>
						<ul>
							<li>Perché non posso selezionare un'opzione di spedizione?</li>
						</ul>
						<p>È probabile che il venditore non abbia incluso un'opzione di spedizione nella vostra regione.</p>
						<ul>
							<li>Come posso cambiare il mio indirizzo o aggiungerne uno nuovo?</li>
						</ul>
						<p>
							Acceda al vostro account MARKETPLACE e clicca su Account&gt;Impostazioni&gt;Spedizione. Qui puoi scegliere
							di 'modificare' un indirizzo esistente o selezionare 'aggiungi un indirizzo'.
						</p>
						<ul>
							<li>Il mio articolo non è stato consegnato, cosa devo fare?</li>
						</ul>
						<p>
							Vi consigliamo di contattare direttamente il negozio per scoprire la situazione del vostro ordine. È
							quindi possibile seguire il vostro ordine e chiedere qualsiasi informazione di monitoraggio che vi aiuterà
							a localizzare il vostro ordine. Se non si riceve una risposta dopo un periodo di tempo ragionevole, è
							possibile escalation della questione. Se hai esaurito altri metodi di escalation, ma il problema rimane
							irrisolto, invia la vostra email di conferma dell'acquisto a ordersupport@marketplace.com e noi la
							prenderemo da lì.
						</p>
						<ul>
							<li>Ci sono addebiti in eccesso su articoli di venditori internazionali? </li>
						</ul>
						<p>
							Se sei un acquirente straniero potresti essere soggetto a dazi e tasse d'importazione, che vengono
							riscossi una volta che il pacco raggiunge il vostro paese. Eventuali oneri aggiuntivi per lo sdoganamento
							devono essere coperti da voi; non abbiamo alcun controllo su questi oneri e non possiamo prevedere quali
							possano essere.
						</p>
						<p>
							Le politiche doganali variano notevolmente da paese a paese, quindi è necessario contattare l'ufficio
							doganale locale per ulteriori informazioni. Inoltre, si prega di notare che quando si ordina da un
							venditore al mercato MARKETPLACE Marketplace, si è considerato l'importatore dell'articolo e deve
							rispettare tutte le leggi e i regolamenti del paese in cui si riceve la merce.
						</p>
					</InfoPageSection>
					<InfoPageSection>
						<InfoPageTitle3>RESTITUZIONE</InfoPageTitle3>
						<p>Può cancellare un ordine dal vostro account prima che venga accettato dal negozio.</p>
						<p>
							Se si riceve un articolo e si desidera restituirlo per qualsiasi motivo è necessario informare il
							venditore per iscritto:
						</p>
						<ul>
							<li>• Entro 14 giorni dal ricevimento dell'articolo.</li>
						</ul>
						<ul>
							<li>
								• È possibile utilizzare il modulo di recesso per comunicare al Venditore se si desidera recedere dal
								contratto ai sensi del Regolamento Contratti di consumo (informazioni, cancellazione e costi aggiuntivi)
								2013.
							</li>
						</ul>
						<ul>
							<li>• Entro 28 giorni se l'articolo diventa difettoso.</li>
						</ul>
						<p>
							Il Venditore vi fornirà quindi le istruzioni su come restituire il vostro articolo e, una volta ricevuto
							il vostro articolo, procederà al rimborso secondo il metodo di pagamento originale.
						</p>
						<p>
							L'affrancatura di ritorno è sotto la vostra responsabilità, a meno che l'articolo non sia errato o
							difettoso, nel qual caso il Venditore rimborserà l'affrancatura di ritorno. In caso di annullamento del
							contratto ai sensi del Regolamento Contratti con i consumatori (informazioni, cancellazione e spese
							aggiuntive) 2013, le spese di spedizione standard che ha pagato per ricevere il vostro acquisto saranno
							incluse come parte del vostro rimborso.
						</p>
						<p>
							Gli articoli restituiti devono essere non indossati e nelle loro condizioni originali, salvo il diritto di
							ispezionare la merce e provare i capi. È vostra responsabilità assicurarti di imballare adeguatamente la
							merce restituita in modo che arrivi al Venditore senza danni. In caso di ulteriori domande su resi,
							rimborsi o cancellazioni, si prega di contattare il Venditore.
						</p>
					</InfoPageSection>
				</InfoPage>
				<Helmet
					title={siteTitle}
					link={[{ rel: 'canonical', href: siteUrl }]}
					meta={[
						{ property: 'og:title', content: siteTitle },
						{ property: 'og:image', content: siteImage },
						{ property: 'og:description', content: siteDescription },
						{ property: 'og:url', content: siteUrl },
						{ name: 'title', content: siteTitle },
						{ name: 'description', content: siteDescription },
						{ name: 'keywords', content: siteKeywords },
					]}
				/>
			</PortalOneColumnLayout>
		);
	}
}

export { PortalDeliveryAndReturnsIT };
